/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sui_Chain_Tps_ExplanationInputs */



/**
* | output |
* | --- |
* | "RandomnessStateUpdate, ConsensusCommitPrologueV3, EndOfEpochTransaction, ConsensusCommitPrologue, AuthenticatorStateUpdate, ConsensusCommitPrologueV2 and Cha..." |
*
* @param {Sui_Chain_Tps_ExplanationInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const sui_chain_tps_explanation = /** @type {((inputs?: Sui_Chain_Tps_ExplanationInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sui_Chain_Tps_ExplanationInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("RandomnessStateUpdate, ConsensusCommitPrologueV3, EndOfEpochTransaction, ConsensusCommitPrologue, AuthenticatorStateUpdate, ConsensusCommitPrologueV2 and ChangeEpoch")
});